import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Card, Table, Button, Stack } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import 'assets/styles/common.scss';
import { LocaleContext } from 'routes/Router';
import 'Pages/SuperAdmin/Dashboard/dashboard.scss';
import Provider from 'assets/images/sidebar/ProviderColor.png';
import Customer from 'assets/images/sidebar/Customer.png';
import Appointment from 'assets/images/sidebar/AppointmentColor.png';
import rightArrow from 'assets/images/Dashboard/arrow-right.png';
import Avtar from 'assets/images/Dashboard/avtar.png';
import mail from 'assets/images/Dashboard/mail.png';
import call from 'assets/images/Dashboard/call.png';
import trash from 'assets/images/Dashboard/trash.png';
import Specialist from 'assets/images/Dashboard/Specialist.png';
import ReusableTabs from 'components/common/Tabs';
import { FormattedMessage, useIntl } from 'react-intl';
import SwitchInput from 'components/common/Input/SwitchInput';
import { getDashboardDataCallAPI } from 'store/SuperAdmin/dashboard/action';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import ToastNotification from 'components/common/Toast';
import { deleteCustomerSuperAdminCallAPI } from 'store/SuperAdmin/deleteCustomer/action';
import { deleteProviderSuperAdminCallAPI } from 'store/SuperAdmin/deleteProvider/action';
import {
  superAdminAppointmentsDetails,
  superAdminCompanyProviderDetails,
  superAdminCustomerDetails,
  superAdminSalonProviderDetails,
  superAdminSpecialistProviderDetails,
} from 'routes/AppUrls';
import {
  basicDetailsCallApi,
  DASHBOARD_NEW_USER_SELECTED_TAB,
} from 'store/SuperAdmin/basicDetails/action';
import { useConfirm } from 'material-ui-confirm';
import Lottie from 'lottie-react';
import animationData from 'assets/Lottie/no_data.json';
import { updateProviderStatusCallAPI } from 'store/SuperAdmin/updateProviderStatus/action';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import CustomPopover from 'components/common/CustomPopover';
import { ShimmerBox, ShimmerCircle } from 'components/common/Shimmer';

const Dashboard = () => {
  const navigate = useNavigate();
  const confirm = useConfirm();
  const dispatch = useDispatch();
  const intl = useIntl();
  const [conf, setConf] = ToastNotification();
  const { locale } = useContext(LocaleContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const [viewData, setViewData] = useState('');

  const getNewUserSelectedTab = useSelector(
    (state) => state?.basicDetailsReducer?.dashboardNewUserSelectedTab
  );
  const [tab, setTab] = useState(getNewUserSelectedTab);

  const getDashboardDetails = useSelector(
    (state) => state?.getDashboardDataReducer?.data?.data
  );

  const dashboardLoading = useSelector(
    (state) => state?.getDashboardDataReducer?.loading
  );

  const [dashboardDetails, setDashboardDetails] = useState(
    getDashboardDetails ? getDashboardDetails : ''
  );

  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [newUsersLoading, setNewUsersLoading] = useState(false);

  const handlePopoverClick = (event, item) => {
    setAnchorEl(event.currentTarget);
    setViewData(item);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const PopoverData = [
    {
      label: <FormattedMessage id="Delete" />,
      icon: (
        <DeleteOutlinedIcon style={{ marginRight: '5px', marginTop: '-5px' }} />
      ),
      onClick: () => handleDeleteCustomer(viewData),
    },
  ];

  const tabData = [
    { label: intl.formatMessage({ id: 'Customers' }) },
    { label: intl.formatMessage({ id: 'Specialists' }) },
    { label: intl.formatMessage({ id: 'Salons' }) },
    { label: intl.formatMessage({ id: 'Companies' }) },
  ];

  useEffect(() => {
    // getDashboardApi();
    handleTabChange(tab, true);
  }, []);

  const getDashboardApi = (val = '', isInitial = false) => {
    if (!isInitial) {
      setNewUsersLoading(true);
    }
    dispatch(
      getDashboardDataCallAPI(
        {},
        {
          type: val,
          run: true,
          handleFunction: (res) => handleSuccess(res, isInitial),
          navigate: navigate,
        }
      )
    );
  };

  const handleSuccess = (res, isInitial = false) => {
    setDashboardDetails(res?.data?.data);
    if (!isInitial) {
      setNewUsersLoading(false);
    } else {
      setIsInitialLoad(false);
    }
  };

  const handleTabChange = (val, isInitial = false) => {
    setTab(val);
    dispatch(basicDetailsCallApi(DASHBOARD_NEW_USER_SELECTED_TAB, val));
    if (val === 1) {
      getDashboardApi('', isInitial);
    } else if (val === 2) {
      getDashboardApi('specialist', isInitial);
    } else if (val === 3) {
      getDashboardApi('salon', isInitial);
    } else if (val === 4) {
      getDashboardApi('company', isInitial);
    }
  };

  const handleSwitchChange = (event, data) => {
    let body = {
      status: event?.target?.checked,
    };

    if (tab === 1) {
      body['customer_id'] = data?.id;
    } else {
      body['provider_id'] = data?.id;
    }

    dispatch(
      updateProviderStatusCallAPI(body, {
        run: true,
        tab: tab,
        handleFunction: (res) => handleStatusSuccess(res),
        navigate: navigate,
        toast: true,
        handleToastError: (res) => handleRedirectError(res),
      })
    );
  };

  const handleStatusSuccess = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'success',
    });
    handleTabChange(tab, false);
  };

  const handleRedirectError = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'error',
    });
  };

  const handleDeleteCustomer = (key) => {
    confirm({
      title: 'Confirm Delete',
      description: 'Are you sure you want to delete Customer ?',
      confirmationText: 'Yes',
      cancellationText: 'No',
      dialogProps: { maxWidth: 'xs' },
      confirmationButtonProps: {
        sx: {
          bgcolor: '#292D32',
          color: '#FFFFFF',
          borderRadius: '0px',
          border: '1px solid #292D32',
          '&:hover': { bgcolor: '#292D32' },
        },
      },
      cancellationButtonProps: {
        sx: {
          bgcolor: 'transparent',
          color: '#292D32',
          borderRadius: '0px',
          border: '1px solid #292D32',
        },
      },
    })
      .then(() => handleConfirmDeleteCustomer(key))
      .catch(() => setAnchorEl(null));
  };

  const handleConfirmDeleteCustomer = (key) => {
    if (tab === 1) {
      dispatch(
        deleteCustomerSuperAdminCallAPI(
          {},
          {
            id: key?.id,
            run: true,
            handleFunction: (res) => handleDeleteSuccess(res),
            navigate: navigate,
          }
        )
      );
    } else {
      dispatch(
        deleteProviderSuperAdminCallAPI(
          {},
          {
            id: key?.id,
            run: true,
            handleFunction: (res) => handleDeleteSuccess(res),
            navigate: navigate,
          }
        )
      );
    }
  };

  const handleDeleteSuccess = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'success',
    });
    handleTabChange(tab, false);
  };

  const handleAppointmentDetails = (key) => {
    navigate(superAdminAppointmentsDetails(locale), {
      state: { customerId: key?.id },
    });
  };

  const objectMapping = {
    1: superAdminCustomerDetails,
    2: superAdminSpecialistProviderDetails,
    3: superAdminSalonProviderDetails,
    4: superAdminCompanyProviderDetails,
  };

  const handleViewDetails = (data) => {
    const NavigateFunction = objectMapping?.[tab];
    navigate(NavigateFunction(locale), {
      state: tab === 1 ? { customerId: data?.id } : { data },
    });
  };

  const salonLabels = {
    active_liisted_salons: <FormattedMessage id="Active Listed Salons" />,
    inactive_liisted_salons: <FormattedMessage id="Inactive Listed Salons" />,
    active_onboarded_salons: <FormattedMessage id="Active Onboarded Salons" />,
    inactive_onboarded_salons: `<FormattedMessage id="Inactive Onboarded Salons" />`,
    onboarded_salons: <FormattedMessage id="Onboarded Salons" />,
    //listed_salon: <FormattedMessage id="Listed Salons" />,
    pending_salons: <FormattedMessage id="Pending Salons" />,
    on_hold_salons: <FormattedMessage id="On-Hold Salons" />,
    requested_salon: <FormattedMessage id="Requested Salons" />,
  };

  const specialistLabels = {
    freelancer: <FormattedMessage id="Freelancer" />,
    in_salon: <FormattedMessage id="In-Salon" />,
  };

  const customerLabels = {
    app_users: <FormattedMessage id="App Users" />,
    guest_users: <FormattedMessage id="Guest Users" />,
  };

  const appointmentLabels = {
    cancelled: <FormattedMessage id="Cancelled" />,
    completed: <FormattedMessage id="Completed" />,
    missed: <FormattedMessage id="Missed" />,
    upcoming: <FormattedMessage id="Upcoming" />,
    inprogress: <FormattedMessage id="Inprogress" />,
  };

  const statusColors = {
    listed_salon: { background: '#DBEAFE', text: '#1E40AF' }, // Blue
    onboarded_salons: { background: '#E0E7FF', text: '#3730A3' }, // Indigo
    pending_salons: { background: '#FEF9C3', text: '#92400E' }, // Yellow
    on_hold_salons: { background: '#FFEDD5', text: '#9A3412' }, // Orange
    active_liisted_salons: { background: '#D1FAE5', text: '#065F46' }, // Green
    inactive_liisted_salons: { background: '#FECACA', text: '#991B1B' }, // Red
    active_onboarded_salons: { background: '#D1FAE5', text: '#065F46' }, // Green
    inactive_onboarded_salons: { background: '#FECACA', text: '#991B1B' }, // Red
    cancelled: { background: '#FECACA', text: '#991B1B' }, // Red
    completed: { background: '#D1FAE5', text: '#065F46' }, // Green
    missed: { background: '#FEF9C3', text: '#92400E' }, // Yellow
    freelancer: { background: '#E9D5FF', text: '#6B21A8' }, // Purple
    in_salon: { background: '#DBEAFE', text: '#1E40AF' }, // Blue
    app_users: { background: '#D1FAE5', text: '#065F46' }, // Green
    guest_users: { background: '#FEF9C3', text: '#92400E' }, // Yellow
  };

  return (
    <Row className="bc-F2F3F6 m-0 p-0">
      <Col
        className={
          locale === 'en'
            ? 'commonEnContainer lg:ml-left'
            : 'commonArContainer lg:mr-right'
        }
      >
        <h2 className="fc-292D32 fs-32 fw-400 ff-Akkurat_Bold m-0">
          <FormattedMessage id="Dashboard" />
        </h2>

        <Row className="mt-3 ">
          <Col lg={3} md={6} sm={12}>
            <Card className={locale === 'en' ? 'text-start' : 'text-end'}>
              <Card.Body>
                {isInitialLoad && dashboardLoading ? (
                  <>
                    <div className="flex justify-between p-1">
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center"
                      >
                        <ShimmerBox width="24px" height="24px" />
                        <ShimmerBox width="100px" height="16px" />
                      </Stack>
                      <ShimmerBox width="40px" height="20px" />
                    </div>
                    <div className="p-2 w-full max-w-md mx-auto h-[150px] overflow-y-auto">
                      <div className="space-y-3">
                        {[1, 2, 3, 4].map((subItem) => (
                          <div
                            key={subItem}
                            className="flex items-center justify-between px-3 py-2 rounded-md"
                            style={{
                              backgroundColor: '#F3F4F6',
                            }}
                          >
                            <ShimmerBox width="120px" height="14px" />
                            <ShimmerBox width="30px" height="14px" />
                          </div>
                        ))}
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="flex justify-between p-1">
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center"
                      >
                        <img
                          src={Provider}
                          alt="icon"
                          style={{ height: '24px', width: '24px' }}
                        />
                        <p className="p-0 m-0 fs-16 fc-9A9A9A fw-400 ff-Akkurat truncate">
                          <FormattedMessage id="Total Salons" />
                        </p>
                      </Stack>
                      <p className="p-0 m-0 fs-20 fc-292D32 fw-400 ff-Akkurat_Bold truncate">
                        {dashboardDetails?.count_data?.salon_data?.total_salon}
                      </p>
                    </div>

                    <div className="p-2 w-full max-w-md mx-auto h-[150px] overflow-y-auto">
                      <div className="space-y-3">
                        {Object.entries(
                          dashboardDetails?.count_data?.salon_data || {}
                        ).map(
                          ([key, value]) =>
                            salonLabels[key] && (
                              <div
                                key={key}
                                className={`flex items-center justify-between px-3 py-2 rounded-md `}
                                style={{
                                  backgroundColor: '#F3F4F6',
                                  color: '#111827',
                                }}
                              >
                                <span className="text-sm font-medium">
                                  {salonLabels[key]}
                                </span>
                                <span className="text-sm font-bold">
                                  {value}
                                </span>
                              </div>
                            )
                        )}
                      </div>
                    </div>
                  </>
                )}
              </Card.Body>
            </Card>
          </Col>
          <Col lg={3} md={6} sm={12}>
            <Card className={locale === 'en' ? 'text-start' : 'text-end'}>
              <Card.Body>
                {isInitialLoad && dashboardLoading ? (
                  <>
                    <div className="flex justify-between p-1">
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center"
                      >
                        <ShimmerBox width="24px" height="24px" />
                        <ShimmerBox width="100px" height="16px" />
                      </Stack>
                      <ShimmerBox width="40px" height="20px" />
                    </div>
                    <div className="p-2 w-full max-w-md mx-auto h-[150px] overflow-y-auto">
                      <div className="space-y-3">
                        {[1, 2, 3, 4].map((subItem) => (
                          <div
                            key={subItem}
                            className="flex items-center justify-between px-3 py-2 rounded-md"
                            style={{
                              backgroundColor: '#F3F4F6',
                            }}
                          >
                            <ShimmerBox width="120px" height="14px" />
                            <ShimmerBox width="30px" height="14px" />
                          </div>
                        ))}
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="flex justify-between p-1">
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center"
                      >
                        <img
                          src={Specialist}
                          alt="icon"
                          style={{ height: '24px', width: '24px' }}
                        />
                        <p className="p-0 m-0 fs-16 fc-9A9A9A fw-400 ff-Akkurat truncate">
                          <FormattedMessage id="Total Specialists" />
                        </p>
                      </Stack>
                      <p className="p-0 m-0 fs-20 fc-292D32 fw-400 ff-Akkurat_Bold truncate">
                        {
                          dashboardDetails?.count_data?.specialist_data
                            ?.total_specialist
                        }
                      </p>
                    </div>

                    <div className="p-2 w-full max-w-md mx-auto h-[150px] overflow-y-auto">
                      <div className="space-y-3">
                        {Object.entries(
                          dashboardDetails?.count_data?.specialist_data || {}
                        ).map(
                          ([key, value]) =>
                            specialistLabels[key] && (
                              <div
                                key={key}
                                className={`flex items-center justify-between px-3 py-2 rounded-md `}
                                style={{
                                  backgroundColor: '#F3F4F6',
                                  color: '#111827',
                                }}
                              >
                                <span className="text-sm font-medium">
                                  {specialistLabels[key]}
                                </span>
                                <span className="text-sm font-bold">
                                  {value}
                                </span>
                              </div>
                            )
                        )}
                      </div>
                    </div>
                  </>
                )}
              </Card.Body>
            </Card>
          </Col>
          <Col lg={3} md={6} sm={12}>
            <Card className={locale === 'en' ? 'text-start' : 'text-end'}>
              <Card.Body>
                {isInitialLoad && dashboardLoading ? (
                  <>
                    <div className="flex justify-between p-1">
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center"
                      >
                        <ShimmerBox width="24px" height="24px" />
                        <ShimmerBox width="100px" height="16px" />
                      </Stack>
                      <ShimmerBox width="40px" height="20px" />
                    </div>
                    <div className="p-2 w-full max-w-md mx-auto h-[150px] overflow-y-auto">
                      <div className="space-y-3">
                        {[1, 2, 3, 4].map((subItem) => (
                          <div
                            key={subItem}
                            className="flex items-center justify-between px-3 py-2 rounded-md"
                            style={{
                              backgroundColor: '#F3F4F6',
                            }}
                          >
                            <ShimmerBox width="120px" height="14px" />
                            <ShimmerBox width="30px" height="14px" />
                          </div>
                        ))}
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="flex justify-between p-1">
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center"
                      >
                        <img
                          src={Customer}
                          alt="icon"
                          style={{ height: '24px', width: '24px' }}
                        />
                        <p className="p-0 m-0 fs-16 fc-9A9A9A fw-400 ff-Akkurat truncate">
                          <FormattedMessage id="Total Customers" />
                        </p>
                      </Stack>
                      <p className="p-0 m-0 fs-20 fc-292D32 fw-400 ff-Akkurat_Bold truncate">
                        {
                          dashboardDetails?.count_data?.customuser_data
                            ?.total_customuser
                        }
                      </p>
                    </div>

                    <div className="p-2 w-full max-w-md mx-auto h-[150px] overflow-y-auto">
                      <div className="space-y-3">
                        {Object.entries(
                          dashboardDetails?.count_data?.customuser_data || {}
                        ).map(
                          ([key, value]) =>
                            customerLabels[key] && (
                              <div
                                key={key}
                                className={`flex items-center justify-between px-3 py-2 rounded-md `}
                                style={{
                                  backgroundColor: '#F3F4F6',
                                  color: '#111827',
                                }}
                              >
                                <span className="text-sm font-medium">
                                  {customerLabels[key]}
                                </span>
                                <span className="text-sm font-bold">
                                  {value}
                                </span>
                              </div>
                            )
                        )}
                      </div>
                    </div>
                  </>
                )}
              </Card.Body>
            </Card>
          </Col>
          <Col lg={3} md={6} sm={12}>
            <Card className={locale === 'en' ? 'text-start' : 'text-end'}>
              <Card.Body>
                {isInitialLoad && dashboardLoading ? (
                  <>
                    <div className="flex justify-between p-1">
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center"
                      >
                        <ShimmerBox width="24px" height="24px" />
                        <ShimmerBox width="100px" height="16px" />
                      </Stack>
                      <ShimmerBox width="40px" height="20px" />
                    </div>
                    <div className="p-2 w-full max-w-md mx-auto h-[150px] overflow-y-auto">
                      <div className="space-y-3">
                        {[1, 2, 3, 4].map((subItem) => (
                          <div
                            key={subItem}
                            className="flex items-center justify-between px-3 py-2 rounded-md"
                            style={{
                              backgroundColor: '#F3F4F6',
                            }}
                          >
                            <ShimmerBox width="120px" height="14px" />
                            <ShimmerBox width="30px" height="14px" />
                          </div>
                        ))}
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="flex justify-between p-1">
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center"
                      >
                        <img
                          src={Appointment}
                          alt="icon"
                          style={{ height: '24px', width: '24px' }}
                        />
                        <p className="p-0 m-0 fs-16 fc-9A9A9A fw-400 ff-Akkurat truncate">
                          <FormattedMessage id="Total Appointments" />
                        </p>
                      </Stack>
                      <p className="p-0 m-0 fs-20 fc-292D32 fw-400 ff-Akkurat_Bold truncate">
                        {
                          dashboardDetails?.count_data?.appointment_data
                            ?.total_appointment
                        }
                      </p>
                    </div>

                    <div className="p-2 w-full max-w-md mx-auto h-[150px] overflow-y-auto">
                      <div className="space-y-3">
                        {Object.entries(
                          dashboardDetails?.count_data?.appointment_data || {}
                        ).map(
                          ([key, value]) =>
                            appointmentLabels[key] && (
                              <div
                                key={key}
                                className={`flex items-center justify-between px-3 py-2 rounded-md`}
                                style={{
                                  backgroundColor: '#F3F4F6',
                                  color: '#111827',
                                }}
                              >
                                <span className="text-sm font-medium">
                                  {appointmentLabels[key]}
                                </span>
                                <span className="text-sm font-bold">
                                  {value}
                                </span>
                              </div>
                            )
                        )}
                      </div>
                    </div>
                  </>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className="mt-4 pt-1">
          <div className="d-flex justify-content-between align-items-center ">
            <h5 className="p-0 m-0 fs-20 fc-292D32 fw-400 ff-Akkurat_Bold">
              <FormattedMessage id="Appointments Today" />
            </h5>
            {/* <Stack
              direction="horizontal"
              gap={2}
              className="items-center underline underline-offset-4"
            >
              <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat">
                <FormattedMessage id="View All" />
              </p>
              <img
                src={rightArrow}
                alt="icon"
                style={{ height: '20px', width: '20px' }}
              />
            </Stack> */}
          </div>
        </Row>

        <Row className="mt-3 listHeader m-0 p-0 flex items-center">
          <Col lg={1} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
              <FormattedMessage id="Booking ID" />
            </p>
          </Col>
          <Col lg={2} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
              <FormattedMessage id="Customer" />
            </p>
          </Col>
          <Col lg={2} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
              <FormattedMessage id="Provider" />
            </p>
          </Col>
          <Col lg={4} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
              <FormattedMessage id="Service Location" />
            </p>
          </Col>
          <Col lg={2} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
              <FormattedMessage id="Date & Time" />
            </p>
          </Col>
          <Col lg={1} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
              <FormattedMessage id="Actions" />
            </p>
          </Col>
        </Row>

        <Row className="bc-FFFFFF m-0 p-0">
          {isInitialLoad && dashboardLoading ? (
            <>
              {[1, 2, 3, 4, 5].map((item) => (
                <Row
                  key={item}
                  className="m-0 p-0 flex items-center listAppointment"
                >
                  <Col lg={1} md={6} sm={12}>
                    <ShimmerBox width="80px" height="12px" />
                  </Col>
                  <Col lg={2} md={6} sm={12}>
                    <div className="flex items-center gap-2">
                      <ShimmerCircle size="40px" />
                      <div>
                        <ShimmerBox width="120px" height="12px" />
                        <ShimmerBox
                          width="100px"
                          height="12px"
                          className="mt-1"
                        />
                      </div>
                    </div>
                  </Col>
                  <Col lg={2} md={6} sm={12}>
                    <div className="flex items-center gap-2">
                      <ShimmerCircle size="40px" />
                      <div>
                        <ShimmerBox width="120px" height="12px" />
                        <ShimmerBox
                          width="100px"
                          height="12px"
                          className="mt-1"
                        />
                      </div>
                    </div>
                  </Col>
                  <Col lg={4} md={6} sm={12}>
                    <div className="flex items-center gap-2">
                      <ShimmerBox width="24px" height="24px" />
                      <ShimmerBox width="150px" height="14px" />
                    </div>
                    <ShimmerBox width="200px" height="12px" className="mt-1" />
                  </Col>
                  <Col lg={2} md={6} sm={12}>
                    <ShimmerBox width="100px" height="12px" />
                    <ShimmerBox width="80px" height="12px" className="mt-1" />
                  </Col>
                  <Col lg={1} md={6} sm={12}>
                    <ShimmerBox width="100px" height="14px" />
                  </Col>
                </Row>
              ))}
            </>
          ) : dashboardDetails?.appoinment_today?.length > 0 ? (
            dashboardDetails.appoinment_today.map((key, index) => (
              <Row
                key={index}
                className="m-0 p-0 flex items-center listAppointment"
              >
                <Col lg={1} md={6} sm={12}>
                  <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat">
                    {key?.booking_id}
                  </p>
                </Col>
                <Col lg={2} md={6} sm={12}>
                  <Stack
                    direction="horizontal"
                    gap={2}
                    className="items-center"
                  >
                    <img
                      src={key?.customers_image ? key?.customers_image : Avtar}
                      alt="icon"
                      style={{
                        height: '40px',
                        width: '40px',
                        borderRadius: '100px',
                      }}
                    />
                    <div>
                      <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat_Bold">
                        {key?.customers_data?.customers_name}
                      </p>
                      <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat">
                        {key?.customers_data?.customers_id}
                      </p>
                    </div>
                  </Stack>
                </Col>

                <Col lg={2} md={6} sm={12}>
                  <Stack
                    direction="horizontal"
                    gap={2}
                    className="items-center"
                  >
                    <img
                      src={key?.provider_image ? key?.provider_image : Avtar}
                      alt="icon"
                      style={{
                        height: '40px',
                        width: '40px',
                        borderRadius: '100px',
                      }}
                    />
                    <div>
                      <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat_Bold">
                        {key?.provider_data?.name}
                      </p>
                      <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat">
                        {key?.provider_data?.provider_id}
                      </p>
                    </div>
                  </Stack>
                </Col>
                <Col lg={4} md={6} sm={12}>
                  <Stack
                    direction="horizontal"
                    gap={2}
                    className="items-center"
                  >
                    <img
                      src={Provider}
                      alt="icon"
                      style={{ height: '24px', width: '24px' }}
                    />
                    <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold">
                      {key?.service_location}
                    </p>
                  </Stack>
                  <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat mt-1 truncate">
                    {key?.delivery_address}
                  </p>
                </Col>
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat">
                    {key?.slot_date !== null && key?.slot_date !== undefined
                      ? moment(key?.slot_date).format('DD MMM YYYY')
                      : ''}
                  </p>
                  <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat">
                    {key?.slot_start_time !== null &&
                    key?.slot_start_time !== undefined
                      ? moment(key?.slot_start_time).format('h:mm A')
                      : ''}
                  </p>
                </Col>
                <Col lg={1} md={6} sm={12}>
                  <Stack
                    direction="horizontal"
                    gap={2}
                    className="items-center cursor-pointer"
                    onClick={() => handleAppointmentDetails(key)}
                  >
                    <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold underline underline-offset-4">
                      <FormattedMessage id="View Details" />
                    </p>
                    <img
                      src={rightArrow}
                      alt="icon"
                      style={{ height: '20px', width: '20px' }}
                    />
                  </Stack>
                </Col>
              </Row>
            ))
          ) : (
            <Row className="bc-FFFFFF m-0 p-50 flex justify-center items-center">
              <Lottie
                animationData={animationData}
                loop={true}
                style={{ height: '200px', width: '200px' }}
              />
            </Row>
          )}
        </Row>

        <Row className="m-0 p-0 mt-5">
          <h2 className="p-0 m-0 fs-20 fc-292D32 fw-400 ff-Akkurat_Bold">
            <FormattedMessage id="New Users" />
          </h2>
          <Col md={12} lg={12} xl={12} xxl={8} className="m-0 p-0 mt-3">
            <ReusableTabs
              tabs={tabData}
              defaultTab={tab}
              currentTab={(val) => handleTabChange(val)}
            />
          </Col>
        </Row>

        {/* {tab === 1 && ( */}
        <>
          {tab === 1 && (
            <Row className="mt-3 listHeader m-0 p-0 flex items-center">
              <Col lg={1} md={6} sm={12}>
                <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold truncate">
                  <FormattedMessage id="Customer" />
                </p>
              </Col>
              <Col lg={1} md={6} sm={12}>
                <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold truncate">
                  <FormattedMessage id="User Type" />
                </p>
              </Col>
              <Col lg={1} md={6} sm={12}>
                <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold truncate">
                  <FormattedMessage id="Joined On" />
                </p>
              </Col>
              <Col lg={1} md={6} sm={12}>
                <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold truncate">
                  <FormattedMessage id="Location" />
                </p>
              </Col>
              <Col lg={2} md={6} sm={12}>
                <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold truncate">
                  <FormattedMessage id="Contact Info" />
                </p>
              </Col>
              <Col lg={1} md={6} sm={12} className="flex justify-center">
                <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold truncate">
                  <FormattedMessage id="Frequency" />
                </p>
              </Col>
              <Col lg={1} md={6} sm={12}>
                <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold truncate">
                  <FormattedMessage id="Last Used" />
                </p>
              </Col>
              <Col lg={1} md={6} sm={12}>
                <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold truncate">
                  <FormattedMessage id="Last Activity" />
                </p>
              </Col>
              <Col lg={1} md={6} sm={12}>
                <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold truncate">
                  <FormattedMessage id="Status" />
                </p>
              </Col>
              <Col lg={2} md={6} sm={12} className="flex justify-center">
                <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold truncate">
                  <FormattedMessage id="Actions" />
                </p>
              </Col>
            </Row>
          )}

          {(tab === 2 || tab == 3 || tab === 4) && (
            <Row className="mt-3 listHeader m-0 p-0 flex items-center">
              <Col lg={2} md={6} sm={12}>
                <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold truncate">
                  {tab === 2 && <FormattedMessage id="Specialist" />}
                  {tab === 3 && <FormattedMessage id="Salon" />}
                  {tab === 4 && <FormattedMessage id="Company" />}
                </p>
              </Col>
              <Col lg={2} md={6} sm={12}>
                <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold truncate">
                  <FormattedMessage id="Location" />
                </p>
              </Col>
              <Col lg={2} md={6} sm={12}>
                <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold truncate">
                  <FormattedMessage id="Contact Info" />
                </p>
              </Col>
              <Col lg={2} md={6} sm={12}>
                <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold truncate">
                  <FormattedMessage id="Joined On" />
                </p>
              </Col>
              <Col lg={2} md={6} sm={12}>
                <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold truncate">
                  <FormattedMessage id="Status" />
                </p>
              </Col>
              <Col lg={2} md={6} sm={12}>
                <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold truncate">
                  <FormattedMessage id="Actions" />
                </p>
              </Col>
            </Row>
          )}

          <Row className="bc-FFFFFF m-0 p-0">
            {newUsersLoading || (isInitialLoad && dashboardLoading) ? (
              <>
                {tab === 1 && (
                  <>
                    {[1, 2, 3, 4, 5].map((item) => (
                      <Row
                        key={item}
                        className="m-0 p-0 flex items-center listAppointment"
                      >
                        <Col lg={1} md={6} sm={12}>
                          <ShimmerBox width="100px" height="14px" />
                          <ShimmerBox
                            width="80px"
                            height="12px"
                            className="mt-1"
                          />
                        </Col>
                        <Col lg={1} md={6} sm={12}>
                          <ShimmerBox width="80px" height="12px" />
                        </Col>
                        <Col lg={1} md={6} sm={12}>
                          <ShimmerBox width="100px" height="14px" />
                        </Col>
                        <Col lg={1} md={6} sm={12}>
                          <ShimmerBox width="120px" height="12px" />
                        </Col>
                        <Col lg={2} md={6} sm={12}>
                          <ShimmerBox width="150px" height="12px" />
                          <ShimmerBox
                            width="120px"
                            height="12px"
                            className="mt-2"
                          />
                        </Col>
                        <Col
                          lg={1}
                          md={6}
                          sm={12}
                          className="flex justify-center"
                        >
                          <ShimmerBox width="40px" height="12px" />
                        </Col>
                        <Col lg={1} md={6} sm={12}>
                          <ShimmerBox width="100px" height="12px" />
                        </Col>
                        <Col lg={1} md={6} sm={12}>
                          <ShimmerBox width="120px" height="12px" />
                        </Col>
                        <Col lg={1} md={6} sm={12}>
                          <ShimmerBox width="50px" height="20px" />
                        </Col>
                        <Col
                          lg={2}
                          md={6}
                          sm={12}
                          className="flex justify-center"
                        >
                          <ShimmerBox width="100px" height="14px" />
                        </Col>
                      </Row>
                    ))}
                  </>
                )}
                {(tab === 2 || tab === 3 || tab === 4) && (
                  <>
                    {[1, 2, 3, 4, 5].map((item) => (
                      <Row
                        key={item}
                        className="m-0 p-0 flex items-center listAppointment"
                      >
                        <Col lg={2} md={6} sm={12}>
                          <ShimmerBox width="150px" height="14px" />
                          <ShimmerBox
                            width="100px"
                            height="12px"
                            className="mt-1"
                          />
                        </Col>
                        <Col lg={2} md={6} sm={12}>
                          <ShimmerBox width="200px" height="12px" />
                        </Col>
                        <Col lg={2} md={6} sm={12}>
                          <ShimmerBox width="150px" height="12px" />
                          <ShimmerBox
                            width="120px"
                            height="12px"
                            className="mt-2"
                          />
                        </Col>
                        <Col lg={2} md={6} sm={12}>
                          <ShimmerBox width="100px" height="14px" />
                        </Col>
                        <Col lg={2} md={6} sm={12}>
                          <ShimmerBox width="50px" height="20px" />
                        </Col>
                        <Col lg={2} md={6} sm={12}>
                          <ShimmerBox width="100px" height="14px" />
                        </Col>
                      </Row>
                    ))}
                  </>
                )}
              </>
            ) : dashboardDetails?.new_user_details?.length > 0 ? (
              dashboardDetails.new_user_details.map((key, index) => (
                <>
                  {tab === 1 && (
                    <Row
                      key={index}
                      className="m-0 p-0 flex items-center listAppointment"
                    >
                      <Col lg={1} md={6} sm={12}>
                        <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold">
                          {key?.name?.name_en}
                        </p>
                        <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat">
                          {key?.id}
                        </p>
                      </Col>

                      <Col lg={1} md={6} sm={12}>
                        <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat mt-1">
                          {key?.role}
                        </p>
                      </Col>

                      <Col lg={1} md={6} sm={12}>
                        <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat">
                          {(key?.joining_on !== null ||
                            key?.joining_on !== undefined) &&
                            moment(key?.joining_on).format('DD MMM YYYY')}
                        </p>
                      </Col>

                      <Col lg={1} md={6} sm={12}>
                        <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat mt-1 truncate">
                          {key?.address}
                        </p>
                      </Col>

                      <Col lg={2} md={6} sm={12}>
                        <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat_Bold">
                          <Stack
                            direction="horizontal"
                            gap={2}
                            className="items-center "
                          >
                            <img
                              src={mail}
                              alt="icon"
                              style={{ height: '20px', width: '20px' }}
                            />
                            <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat truncate">
                              {key?.email}
                            </p>
                          </Stack>
                          <Stack
                            direction="horizontal"
                            gap={2}
                            className="items-center mt-2"
                          >
                            <img
                              src={call}
                              alt="icon"
                              style={{ height: '20px', width: '20px' }}
                            />
                            <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat">
                              {key?.contact_number}
                            </p>
                          </Stack>
                        </p>
                      </Col>

                      <Col
                        lg={1}
                        md={6}
                        sm={12}
                        className="flex justify-center"
                      >
                        <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat mt-1">
                          {key?.frequency}
                        </p>
                      </Col>

                      <Col lg={1} md={6} sm={12}>
                        <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat mt-1">
                          {key?.last_used
                            ? moment(key?.last_used).format('DD MMM YYYY')
                            : ''}
                        </p>
                      </Col>

                      <Col lg={1} md={6} sm={12}>
                        <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat mt-1 truncate">
                          {key?.last_activity?.[0]?.last_activity}
                        </p>
                      </Col>

                      <Col lg={1} md={6} sm={12}>
                        <SwitchInput
                          label={true}
                          checked={key?.status}
                          onChange={(e) => handleSwitchChange(e, key)}
                          color="secondary"
                        />
                      </Col>

                      <Col
                        lg={2}
                        md={6}
                        sm={12}
                        className="flex justify-center"
                      >
                        <Stack
                          direction="horizontal"
                          gap={3}
                          className="items-center "
                        >
                          {/* <img
                            className="cursor-pointer"
                            src={trash}
                            alt="icon"
                            style={{ height: '24px', width: '24px' }}
                            onClick={() => handleDeleteCustomer(key)}
                          /> */}

                          <Stack
                            direction="horizontal"
                            gap={2}
                            className="items-center cursor-pointer"
                            onClick={() => handleViewDetails(key)}
                          >
                            <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold underline underline-offset-4">
                              <FormattedMessage id="View Details" />
                            </p>
                            <img
                              src={rightArrow}
                              alt="icon"
                              style={{ height: '20px', width: '20px' }}
                            />
                          </Stack>

                          <div>
                            <MoreVertIcon
                              aria-describedby={id}
                              style={{ fill: '#3C1053', cursor: 'pointer' }}
                              onClick={(e) => handlePopoverClick(e, key)}
                            />
                            <CustomPopover
                              id={id}
                              open={open}
                              anchorEl={anchorEl}
                              handleClose={handlePopoverClose}
                              options={PopoverData}
                            />
                          </div>
                        </Stack>
                      </Col>
                    </Row>
                  )}

                  {(tab === 2 || tab == 3 || tab === 4) && (
                    <Row
                      key={index}
                      className="m-0 p-0 flex items-center listAppointment"
                    >
                      <Col lg={2} md={6} sm={12}>
                        <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold">
                          {key?.name?.name_en}
                        </p>
                        <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat">
                          {key?.id}
                        </p>
                      </Col>

                      <Col lg={2} md={6} sm={12}>
                        <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat mt-1">
                          {key?.address}
                        </p>
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat_Bold">
                          <Stack
                            direction="horizontal"
                            gap={2}
                            className="items-center "
                          >
                            <img
                              src={mail}
                              alt="icon"
                              style={{ height: '20px', width: '20px' }}
                            />
                            <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat">
                              {key?.email}
                            </p>
                          </Stack>
                          <Stack
                            direction="horizontal"
                            gap={2}
                            className="items-center mt-2"
                          >
                            <img
                              src={call}
                              alt="icon"
                              style={{ height: '20px', width: '20px' }}
                            />
                            <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat">
                              {key?.contact_number}
                            </p>
                          </Stack>
                        </p>
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat">
                          {(key?.joining_on !== null ||
                            key?.joining_on !== undefined) &&
                            moment(key?.joining_on).format('DD MMM YYYY')}
                        </p>
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <SwitchInput
                          label={true}
                          checked={key?.provider_status}
                          onChange={(e) => handleSwitchChange(e, key)}
                          color="secondary"
                        />
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <Stack
                          direction="horizontal"
                          gap={3}
                          className="items-center "
                        >
                          {/* <img
                            className="cursor-pointer"
                            src={trash}
                            alt="icon"
                            style={{ height: '24px', width: '24px' }}
                            onClick={() => handleDeleteCustomer(key)}
                          /> */}

                          <Stack
                            direction="horizontal"
                            gap={2}
                            className="items-center cursor-pointer"
                            onClick={() => handleViewDetails(key)}
                          >
                            <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold underline underline-offset-4">
                              <FormattedMessage id="View Details" />
                            </p>
                            <img
                              src={rightArrow}
                              alt="icon"
                              style={{ height: '20px', width: '20px' }}
                            />
                          </Stack>

                          <div>
                            <MoreVertIcon
                              aria-describedby={id}
                              style={{ fill: '#3C1053', cursor: 'pointer' }}
                              onClick={(e) => handlePopoverClick(e, key)}
                            />
                            <CustomPopover
                              id={id}
                              open={open}
                              anchorEl={anchorEl}
                              handleClose={handlePopoverClose}
                              options={PopoverData}
                            />
                          </div>
                        </Stack>
                      </Col>
                    </Row>
                  )}
                </>
              ))
            ) : (
              <Row className="bc-FFFFFF m-0 p-50 flex justify-center items-center">
                <Lottie
                  animationData={animationData}
                  loop={true}
                  style={{ height: '200px', width: '200px' }}
                />
              </Row>
            )}
          </Row>
        </>
      </Col>
    </Row>
  );
};

export default Dashboard;
